import { ReactNode } from 'react';

interface CardGridProps {
  children: ReactNode;
  columns?: number;
}

export const CardGrid = ({ children, columns = 2 }: CardGridProps) => {
  const gridCols =
    columns === 1
      ? 'grid-cols-1'
      : columns === 2
        ? 'grid-cols-1 md:grid-cols-2'
        : columns === 3
          ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'
          : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4';

  return <div className={`grid ${gridCols} gap-6`}>{children}</div>;
};
